import { composeReducers } from 'common/util';
import lodash from 'lodash';

import {
    WRITE_DELEGATION_AUDIT_LOG_DATA,
} from 'pages/delegationOfAuthority/actions/studyAuditLog';


export function retrieveStudyAuditLogData(state, action) {
    if (!action || action.type !== WRITE_DELEGATION_AUDIT_LOG_DATA) {
        return state;
    }

    const auditLogEntries = lodash.get(action, 'payload.auditLogEntries', []);
    const uniqueAssetIds = new Set(auditLogEntries.map(entry => entry.assetId));

    const doaAuditHistory = {};
    uniqueAssetIds.forEach(assetId => {
        const createAndEditEvents = auditLogEntries.filter(event => event.assetId === assetId);
        const signatureEvents = auditLogEntries.filter(event => {
            const result = JSON.parse(event.value);
            return result.delegationId === assetId;
        });

        const combinedEvents = createAndEditEvents.concat(signatureEvents);
        combinedEvents.sort((a,b) => new Date(a.createdAt) - new Date(b.createdAt));
        doaAuditHistory[assetId] = combinedEvents;
    });

    return {
        ...state,
        doaAuditHistory,
    };
}

export default composeReducers(
    retrieveStudyAuditLogData,
);
